<app-location-evse
  [evse]="updatedEvse()"
  [messages]="messages()"
></app-location-evse>
